import { getForEveryBreakpoint } from '../../utils/breakpoints';
import { COLUMNS, getSyncedMaxQuery } from '../../utils/layout';
import { SPACINGS } from '../../utils/spacings';
const generateSpacingClasses = (breakpoint) => {
    const windowWidth = breakpoint.replace('px', '');
    return SPACINGS.reduce((classes, spacing) => (Object.assign(Object.assign({}, classes), { [`${windowWidth}_${spacing}`]: {
            '@media': {
                [`screen and (min-width: ${breakpoint})`]: {
                    padding: `0 ${spacing / 2}px`,
                },
            },
        } })), {});
};
const generateWidthClasses = (breakpoint) => {
    const windowWidth = breakpoint.replace('px', '');
    return Object.entries(COLUMNS).reduce((classes, [column, width]) => (Object.assign(Object.assign({}, classes), { [`${windowWidth}_${column}`]: {
            '@media': {
                [`screen and (min-width: ${breakpoint})`]: {
                    width,
                },
            },
        } })), {});
};
export const responsiveCollapsedColumnClasses = getForEveryBreakpoint((breakpoint) => ({
    [breakpoint]: {
        '@media': {
            [`screen and (max-width: ${getSyncedMaxQuery(breakpoint)})`]: { padding: 0 },
        },
    },
}));
export const baseColumnWidthVariants = Object.entries(COLUMNS).reduce((widths, [fraction, width]) => {
    return Object.assign(Object.assign({}, widths), { [fraction]: { width } });
}, {});
export const responsiveColumnWidthClasses = getForEveryBreakpoint(generateWidthClasses);
export const responsiveColumnSpacingClasses = getForEveryBreakpoint(generateSpacingClasses);
export const getColumnWidthClasses = (argument, baseVariants, responsiveVariants) => {
    if (typeof argument === 'string') {
        return baseVariants[argument];
    }
    const responsiveClasses = [];
    return Object.entries(argument).reduce((rules, rule) => {
        const [breakpoint, columnWidth] = rule;
        const windowWidth = breakpoint.replace('px', '');
        return [...rules, responsiveVariants[`${windowWidth}_${columnWidth}`]];
    }, responsiveClasses);
};
